import { render, staticRenderFns } from "./driver-hos-edit.vue?vue&type=template&id=04d9d3a6&"
import script from "./driver-hos-edit.vue?vue&type=script&lang=js&"
export * from "./driver-hos-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports